import { Component } from '@angular/core';
import { IonicPage, NavController, ModalController, AlertController, NavParams, Platform } from 'ionic-angular';
import {PrintProvider} from '../../providers/print/print';
import {PrinterListModalPage} from '../printer-list-modal/printer-list-modal';
import { B01SalesPage } from '../b01-sales/b01-sales';
import { B03ReportPage } from '../b03-report/b03-report';
import { B02RefundPage } from '../b02-refund/b02-refund';

/**
 * Generated class for the B08PrinterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b08-printer',
  templateUrl: 'b08-printer.html',
})
export class B08PrinterPage {

  selectedPrinter:any=[];
  fromPage:any;
  constructor(public navCtrl: NavController,public platform:Platform, private modalCtrl:ModalController,
    private printProvider:PrintProvider,public navParams:NavParams,
    private alertCtrl:AlertController) {
      console.log(this.navParams.get('param2'));
      this.fromPage = this.navParams.get('param2');
      this.platform.registerBackButtonAction(() => {
        this.navCtrl.pop();
      },1);
        
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad B08PrinterPage');
  }

  ionViewWillEnter()
  {
    console.log("Im Enter");
    this.platform.registerBackButtonAction(() => {
      this.navCtrl.pop();
    },1);
  }
  listBTDevice()
  {

    
    //callback
    var callbackFunction = function (params) {
      return new Promise((resolve, reject) => {
        console.log("Im Enter1");
        this.platform.registerBackButtonAction(() => {
          this.navCtrl.pop();
        },1);
        resolve();
      });
    }
    this.printProvider.searchBt().then(datalist=>{
      
      //1. Open printer select modal
      let abc=this.modalCtrl.create(PrinterListModalPage,{data:datalist,callback:callbackFunction});
      
      //2. Printer selected, save into this.selectedPrinter
      abc.onDidDismiss(data=>{
        this.platform.registerBackButtonAction(() => {
          this.navCtrl.pop();
        },1);
        this.selectedPrinter=data;

        let xyz=this.alertCtrl.create({
          title: data.name+" selected",
          buttons:['Ok']
        });
        xyz.present();

      });
      
      //0. Present Modal
      abc.present();

    },err=>{
      console.log("ERROR",err);
      let mno=this.alertCtrl.create({
        title:"ERROR "+err,
        buttons:['OK']
      });
      mno.present();
    })

  }

  testConnectPrinter()
  {
    var id=this.selectedPrinter.id;
    if(id==null||id==""||id==undefined)
    {
      //nothing happens, you can put an alert here saying no printer selected
    }
    else
    {
      let foo=this.printProvider.connectBT(id).subscribe(data=>{
        console.log("CONNECT SUCCESSFUL",data);

        let mno=this.alertCtrl.create({
          title:"Connect successful",
          buttons:['OK']
        });
        mno.present();

      },err=>{
        console.log("Not able to connect",err);
        let mno=this.alertCtrl.create({
          title:"ERROR "+err,
          buttons:['OK']
        });
        mno.present();
      });
    }
  }

  // [CXY:01/06/2020:CR/MPOS/20-02]:Modified
  testPrinter()
  {
    var id=this.selectedPrinter.id;   

    if(id==null||id==""||id==undefined)
    {
      //nothing happens, you can put an alert here saying no printer selected
    }
    else
    {
      // START: [CXY:01/06/2020:CR/MPOS/20-02]:Added
      var printerName = this.selectedPrinter.name;
      printerName = printerName.substring(0, 3);
      var param1 = '';
      var param2 = '';
      var param3 = '';
      var param4 = '';
      var param5 = '';
      var param6 = '';
      var param7 = '';

      if(printerName == "MPT") {
        param1 = this.navParams.get('param9');
        param2 = this.navParams.get('param10');
        param3 = this.navParams.get('param11');
        param4 = this.navParams.get('param12');
        param5 = this.navParams.get('param13');
        param6 = this.navParams.get('param14');
        param7 = this.navParams.get('param15');
      }
      else
      {
        param1 = this.navParams.get('param1');
        param2 = this.navParams.get('param3');
        param3 = this.navParams.get('param4');
        param4 = this.navParams.get('param5');
        param5 = this.navParams.get('param6');
        param6 = this.navParams.get('param7');
        param7 = this.navParams.get('param8');
      }
      // END: [CXY:01/06/2020:CR/MPOS/20-02]:Added

      let message = param1;
      let message1 = param2;
      let message2 = param3;
      let message3 = param4;
      let message4 = param5;
      let message5 = param6;
      let message6 = param7;
    
      let foo=this.printProvider.testPrint(1,id, message, message1, message2, message3, message4, message5, message6);
      console.log(foo);
    }
  }

  complete(){
    if (this.fromPage == '1'){
      this.navCtrl.setRoot(B01SalesPage);
    }
    else if (this.fromPage == '2'){
      this.navCtrl.setRoot(B03ReportPage);
    }
    else {
      this.navCtrl.setRoot(B02RefundPage);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/b08-printer/b08-printer.ts